import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, DEFAULT_CURRENCY_CODE, DoBootstrap, Injector, NgModule, Type } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { CURRENCY_MASK_CONFIG, CurrencyMaskConfig, CurrencyMaskModule } from 'ng2-currency-mask';
import { NgxFloatUiModule } from 'ngx-float-ui';
import { register } from 'swiper/element/bundle';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ApgBeatYourBrokerHeaderComponent } from './components/apg-beat-your-broker/apg-beat-your-broker-header/apg-beat-your-broker-header.component';
import { ApgBeatYourBrokerHeaderModule } from './components/apg-beat-your-broker/apg-beat-your-broker-header/apg-beat-your-broker-header.module';
import { ApgBeatYourBrokerComponent } from './components/apg-beat-your-broker/apg-beat-your-broker.component';
import { ApgBeatYourBrokerModule } from './components/apg-beat-your-broker/apg-beat-your-broker.module';
import { ApgCoverCalculatorComponent } from './components/apg-cover-calculator/apg-cover-calculator.component';
import { ApgCoverCalculatorModule } from './components/apg-cover-calculator/apg-cover-calculator.module';
import { ApgLeadGenComponent } from './components/apg-lead-gen/apg-lead-gen.component';
import { ApgLeadGenModule } from './components/apg-lead-gen/apg-lead-gen.module';
import { ApgMultiClaimCalculatorComponent } from './components/apg-multi-claim-calculator/apg-multi-claim-calculator.component';
import { ApgMultiClaimCalculatorModule } from './components/apg-multi-claim-calculator/apg-multi-claim-calculator.module';
import { ApgOpenBankingComponent } from './components/apg-open-banking/apg-open-banking.component';
import { ApgOpenBankingModule } from './components/apg-open-banking/apg-open-banking.module';
import { ApgQuickQuoteComponent } from './components/apg-quick-quote/apg-quick-quote.component';
import { ApgQuickQuoteModule } from './components/apg-quick-quote/apg-quick-quote.module';
import { SlideshowComponent } from './components/shared/slideshow/slideshow.component';
import { mapIcons } from './icons';
import { SentryProviders } from './sentry';
import { ServiceLocator } from './util/service-locator';

register();

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: "left",
  allowNegative: true,
  decimal: "",
  precision: 0,
  prefix: "£ ",
  suffix: "",
  thousands: ","
}

@NgModule({
  declarations: [AppComponent, SlideshowComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    AppComponent
  ],
  bootstrap: [
    // AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    IonicModule.forRoot(),
    NgxFloatUiModule,
    ApgQuickQuoteModule,
    ApgMultiClaimCalculatorModule,
    ApgCoverCalculatorModule,
    CurrencyMaskModule,
    ApgOpenBankingModule,
    ApgBeatYourBrokerModule,
    ApgBeatYourBrokerHeaderModule,
    ApgLeadGenModule,
    AppRoutingModule
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'GBP' },
    provideHttpClient(withInterceptorsFromDi()),
    ...SentryProviders,
  ]
})
export class AppModule implements DoBootstrap {

  constructor(private injector: Injector) {
    this.declareComponent('apg-multi-claim-calculator', ApgMultiClaimCalculatorComponent);
    this.declareComponent('apg-quick-quote', ApgQuickQuoteComponent)
    this.declareComponent('apg-cover-calculator', ApgCoverCalculatorComponent);
    this.declareComponent('app-slideshow', SlideshowComponent);
    this.declareComponent('apg-open-banking', ApgOpenBankingComponent)
    this.declareComponent('apg-beat-your-broker', ApgBeatYourBrokerComponent)
    this.declareComponent('apg-beat-your-broker-header', ApgBeatYourBrokerHeaderComponent)
    this.declareComponent('apg-lead-gen', ApgLeadGenComponent)
    ServiceLocator.init(injector);
    mapIcons();
  }

  private declareComponent(tag: string, type: Type<any>) {
    const webComponent = createCustomElement(type, { injector: this.injector });
    customElements.define(tag, webComponent);
  }
  ngDoBootstrap() { }
}

